const numberComparator = (valueA, valueB) => {
  const extractNumber = (value) => {
    if (!value) return 0;

    // Wrap the value in a div to easily extract the numeric content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = value;
    const textContent = tempDiv.textContent || tempDiv.innerText || '';
    
    // Parse the numeric value, removing any non-numeric characters except decimal points and minus signs
    const numericValue = parseFloat(textContent.replace(/[^\d.-]/g, ''));
    
    return isNaN(numericValue) ? 0 : numericValue;
  };

  const numA = extractNumber(valueA);
  const numB = extractNumber(valueB);

  return numA - numB;
}

export default {
  numberComparator
};